export const IRAN_TIMEZONE = 'Asia/Tehran';

export const formatIranTime = (date = new Date(), options = {}) =>
  date.toLocaleTimeString('fa-IR', {
    timeZone: IRAN_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...options,
  });

export const formatIranDate = (date = new Date(), options = {}) =>
  date.toLocaleDateString('fa-IR', {
    timeZone: IRAN_TIMEZONE,
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options,
  });

export const formatIranTimeFromIso = (iso, options = {}) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleTimeString('fa-IR', {
      timeZone: IRAN_TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      ...options,
    });
  } catch {
    return iso;
  }
};
